import React, { Component } from 'react';
import { connect } from 'react-redux';
import {withRouter} from "react-router-dom";
import loading from '../assets/loading.gif';

class Document extends Component {
  constructor(props) {
    super(props);
    
    this.state = {
      document: null,
      height: null,
      width: null
    };
    this.returnImg = this.returnImg.bind(this);
    this.updateWindowSize = this.updateWindowSize.bind(this);

    this.controller = new AbortController();
    this.signal = this.controller.signal;
  }

  componentDidMount() {
    this.returnImg();
    
    if (this.props.height && this.props.width) {
      this.setState({height: this.props.height, width: this.props.width});
    }
    
    if (!this.props.link) {
      this.updateWindowSize();
      window.addEventListener('resize', this.updateWindowSize);
    }
  }
  
  componentWillUnmount() {
    if (!this.props.link) {
      window.removeEventListener('resize', this.updateWindowSize);
    }
    this.controller.abort();
  }
  
  updateWindowSize() {
    this.setState({height: window.innerHeight, width: window.innerWidth});
  }
  
  returnImg() {
    let link = this.props.link;
    
    if (!link && this.props.location.pathname.split('/')[1] === 'document') {
      link = '/' + this.props.location.pathname.split('/').slice(2).join('/');
    }
    
    link = process.env.PUBLIC_URL + link;
    
    const width = this.props.width ? this.props.width : 0;
    const height = this.props.height ? this.props.height: 0;

    return fetch(`${link}?width=${width}&height=${height}`, {
      method: 'GET',
      headers: new Headers({
        'Authorization': 'Bearer ' + this.props.user.access_token,
      }),
      signal: this.signal
    })
      .then((response) => response.blob())
      .then((file) => getBase64(file)
        .then((file) => this.setState({document: file}))
      ).catch(e => {
        if (e.name === 'AbortError')
          console.log('API call aborted');
        else
          console.error(e)
      })
  }
  
  render() {
    if (!this.state.document) 
      return (
        <img src={loading} alt='loading' 
             width={this.state.width > 256? 256: this.state.width} 
             height={this.state.height > 256? 256: this.state.height}
             style={{display: 'block', marginLeft: 'auto', marginRight: 'auto'}}
        />
      );
    else if (!this.state.document.includes('application/pdf')) {
      return (
        <img src={this.state.document} alt={this.state.document.name}/>
      );
    } else {
      return (
        <iframe width={this.state.width} height={this.state.height} src={this.state.document} title='pdf'/>
      )
    }
  }
}

function getBase64(file) {
  return new Promise((resolve, reject) => {
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}

const mapStateToProps = function(state) {
  return {
    user: state.oidc.user
  }
};

export const TestDocumentNoRedux = Document;

export default withRouter(connect(mapStateToProps)(Document));